// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteButton_wrapper__NyWO3","deleteBtn":"DeleteButton_deleteBtn__vzqy+"};